import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SAGE_ROUTE_NAME } from '@rabbit/config/enums';
import RegistrationsViewV2 from './RegistrationsViewV2';

const SUPAGARD_TENANT = 'SUPAGARD';

export default function RegistrationsRedirectHandler() {
  const { t } = useTranslation();
  const tenantLink = t('tenantLink');
  const isSupagardTenant = tenantLink === SUPAGARD_TENANT;

  if (isSupagardTenant) {
    // Supagard → render new beta page directly to avoid same-path redirect loops
    return <RegistrationsViewV2 />;
  }

  // Everyone else → old page (now at legacy route)
  return <Navigate to={SAGE_ROUTE_NAME.REGISTRATIONS} replace />;
}
